import { flexCenter, media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const LeftSide = styled.div`
  position: relative;
  margin-right: 30px;
  flex-grow: 1;
  min-width: 50vw;
  min-height: 100vh;
  ${flexCenter};

  & > div {
    margin: 0 auto;
  }

  ${media.tablet`
    min-height: unset;
    margin: 0 auto;
    width: 100%;
  `}
`;
export const RightSide = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const Title = styled.div`
  color: var(--white, #fff);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  ${media.phone`
  margin-top: 25px;
  font-size: 24px;
  line-height: 32px;
  `}
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: calc(100vw - 110px);

  ${media.tablet`
    flex-direction: column;
    width: calc(100vw - 40px);
  `}
`;

export default Wrapper;
